<div id="divIcon">
  <mat-icon class="icon-button" id="iconButton" (click)="onClick()" tabindex="5">{{iconName}}</mat-icon>
</div>
